(function () {
  'use strict';

  function getVisibleCount() {
    if (window.matchMedia('(max-width: 749px)').matches) return 1;
    if (window.matchMedia('(max-width: 989px)').matches) return 2;
    return 4;
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-eride-pdp-videos-track]');
    var slides = root.querySelectorAll('[data-eride-pdp-videos-slide]');
    var nav = root.querySelector('[data-eride-pdp-videos-nav]');
    var prev = root.querySelector('[data-eride-pdp-videos-prev]');
    var next = root.querySelector('[data-eride-pdp-videos-next]');

    if (!track || !slides.length) return;

    var index = 0;

    function maxIndex() {
      return Math.max(0, slides.length - getVisibleCount());
    }

    function update() {
      var visible = getVisibleCount();
      var gap = parseFloat(window.getComputedStyle(track).gap) || 16;
      var slideWidth = slides[0].getBoundingClientRect().width + gap;

      if (slides.length <= visible) {
        track.style.transform = 'translateX(0)';
        if (nav) nav.hidden = true;
        return;
      }

      if (nav) nav.hidden = false;
      index = Math.min(index, maxIndex());
      track.style.transform = 'translateX(-' + index * slideWidth + 'px)';

      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= maxIndex();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        index = Math.max(0, index - 1);
        update();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        index = Math.min(maxIndex(), index + 1);
        update();
      });
    }

    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-eride-pdp-videos]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
